import { useFormik } from "formik";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { addSlackIntegrationAsync } from "../../../redux/slices/integrationSlice";
import { Toaster, TOASTER_TYPES } from "../../../utils/toaster";
import "./IntegrationModal.scss";
import { getUserId } from "../../../utils/SessionHelper";
import Button from "../../common/Button";

// Functional component for Add Integration.
const SlackIntegrationModal = ({ handleModal, refreshIntegrations }) => {
  const dispatch = useDispatch();
  const [showLoader, setShowLoader] = useState(false);
  const [connectionFailed, setConnectionFailed] = useState(false);

  // Formik
  const formik = useFormik({
    initialValues: {
      name: "",
      token: "",
      userId: getUserId(),
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("Please enter name."),
      token: Yup.string().required("Please enter token."),
    }),
    onSubmit: (values) => {
      addIntegration({ ...values });
    },
  });

  const handleCancel = () => {
    handleModal(false);
  };

  const addIntegration = async (values) => {
    setShowLoader(true);
    setConnectionFailed(false);
    const resp = await dispatch(
      addSlackIntegrationAsync({
        name: values.name,
        token: values.token,
        userId: values.userId,
      })
    );

    if (resp && resp.payload && resp.payload.msg) {
      Toaster(TOASTER_TYPES.SUCCESS, resp.payload.msg);
      setShowLoader(false);
      refreshIntegrations();
      handleModal(false);
    } else {
      if (!resp.payload) {
        Toaster(TOASTER_TYPES.ERROR, "Slack integration unsuccessful!");
        setShowLoader(false);
        setConnectionFailed(true);
      } else {
        Toaster(TOASTER_TYPES.ERROR, resp.payload.err.message);
        setShowLoader(false);
        setConnectionFailed(true);
      }
    }
  };

  return (
    <div id="integration-modal">
      <div
        className="modal fade show"
        id="integrationModal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="integrationModalTitle"
        aria-modal="true"
      >
        <div className="modal-dialog modal-md" role="document">
          <form onSubmit={formik.handleSubmit}>
            <div className="modal-content">
              <div className="modal-header d-flex justify-content-start align-items-center">
                <span>Add Slack Integration</span>
              </div>
              <div className="modal-body">
                {showLoader && (
                  <img
                    src="static/img/loader-circle.svg"
                    className="modal-loading-img"
                  />
                )}

                <label className="form-field-name mt-2">
                  Name <span className="mandatory-icon">*</span>
                </label>
                <div className="row">
                  <div className="col col-lg-12">
                    <input
                      type="text"
                      id="Name"
                      placeholder="Name"
                      name="Name"
                      maxLength={50}
                      className="form-control"
                      onChange={(e) => {
                        formik.setFieldValue("name", e.target.value);
                      }}
                      value={formik.values.name}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.name && formik.touched.name && (
                      <div className="error-message">{formik.errors.name}</div>
                    )}
                  </div>
                </div>

                <label className="form-field-name mt-2">
                  Token <span className="mandatory-icon">*</span>
                </label>
                <div className="row">
                  <div className="col col-lg-12">
                    <input
                      type="text"
                      id="Token"
                      placeholder="Token"
                      name="Token"
                      className="form-control"
                      onChange={(e) => {
                        formik.setFieldValue("token", e.target.value);
                      }}
                      value={formik.values.token}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.MetadataFile &&
                      formik.touched.MetadataFile && (
                        <div className="error-message">
                          {formik.errors.MetadataFile}
                        </div>
                      )}
                  </div>
                </div>

                <label className="form-field-name mt-2">
                  Channel <span className="mandatory-icon">*</span>
                </label>
                <div className="row">
                  <div className="col col-lg-12">
                    <input
                      type="text"
                      id="Channel"
                      placeholder="Channel"
                      name="Channel"
                      className="form-control"
                      onChange={(e) => {
                        formik.setFieldValue("channel", e.target.value);
                      }}
                      value={formik.values.channel}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.MetadataFile &&
                      formik.touched.MetadataFile && (
                        <div className="error-message">
                          {formik.errors.MetadataFile}
                        </div>
                      )}
                  </div>
                </div>

                {/* <div className="row mt-2">
                  <div className="col col-md-4 col-lg-3 d-flex justify-content-start align-items-center">
                    <b className="form-field-name ">Key</b>
                    <span className="mandatory-icon">*</span>
                  </div>
                  <div className="col col-lg-6">
                    <input
                      type="text"
                      id="key"
                      placeholder="Key"
                      name="key"
                      maxLength={50}
                      className="modal-input-style px-2"
                      onChange={(e) => {
                        formik.setFieldValue("key", e.target.value);
                      }}
                      value={formik.values.userName}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.key && formik.touched.key && (
                      <div className="error-message">{formik.errors.key}</div>
                    )}
                  </div>
                </div>

                <div className="row mt-2">
                  <div className="col col-md-4 col-lg-3 d-flex justify-content-start align-items-center">
                    <b className="form-field-name ">Value</b>
                    <span className="mandatory-icon">*</span>
                  </div>
                  <div className="col col-lg-6">
                    <input
                      type="text"
                      id="value"
                      placeholder="Value"
                      name="value"
                      maxLength={50}
                      className="modal-input-style px-2"
                      onChange={(e) => {
                        formik.setFieldValue("value", e.target.value);
                      }}
                      value={formik.values.accountId}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.value && formik.touched.value && (
                      <div className="error-message">{formik.errors.value}</div>
                    )}
                  </div>
                </div> */}

                {connectionFailed && (
                  <div className="row mt-2">
                    <div className="col-9 offset-md-3 pl-0 text-danger">
                      Connection failed, please check the details and try again.
                    </div>
                  </div>
                )}

                <div className="mt-4">
                  <Button
                    variant="contained"
                    type="submit"
                    disabled={!formik.isValid}
                  >
                    Add Integration
                  </Button>

                  <span className="separator mx-3"></span>

                  <Button
                    variant="outlined"
                    type="button"
                    onClick={() => handleCancel()}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SlackIntegrationModal;
